import { apiCall, http } from '@/api/http'
import { ApiWrapper } from '@/types/main'
import {
    ClientEvent,
    ClientVisit,
    HotWindowsData,
    HotWindowsSettings,
    HotWindowsTaskType,
    ServiceCatalog,
} from './types'

export async function getHotWindows({
    projectId,
    referenceDate,
    taskType,
    serviceIds,
    minPrice,
    refresh,
}: {
    projectId: string
    referenceDate: string
    taskType: HotWindowsTaskType
    serviceIds?: string[]
    minPrice?: number
    refresh?: boolean
}): Promise<ApiWrapper<HotWindowsData>> {
    const url = 'GCB2/hotWindows/v2/getData'
    return apiCall<any>(() =>
        http.post(url, {
            json: {
                projectId,
                filters: {
                    referenceDate,
                    taskType,
                    serviceIds: serviceIds?.length ? serviceIds : undefined,
                    minPrice: minPrice || undefined,
                    refresh: refresh || undefined,
                },
            },
        })
    )
}

export async function getSettings(projectId: string): Promise<ApiWrapper<HotWindowsSettings>> {
    const url = 'GCB2/hotWindows/settings'
    return apiCall<any>(() => http.get(url, { searchParams: { projectId } }))
}

export async function saveSettings({
    projectId,
    settings,
}: {
    projectId: string
    settings: Partial<HotWindowsSettings>
}): Promise<ApiWrapper<HotWindowsSettings>> {
    const url = 'GCB2/hotWindows/settings'
    return apiCall<any>(() => http.post(url, { json: { projectId, settings } }))
}

/** Каталог услуг проекта для «Настроить услуги» и «Фильтры». */
export async function getServiceCatalog(projectId: string): Promise<ApiWrapper<ServiceCatalog>> {
    const url = 'GCB2/hotWindows/services'
    return apiCall<any>(() => http.get(url, { searchParams: { projectId } }))
}

/**
 * История визитов клиента для карточки — та же ручка, что и в «Кого из
 * клиентов стоит позвать», чтобы данные в двух виджетах не разъезжались.
 */
export async function getClientVisits({
    projectId,
    clientId,
}: {
    projectId: string
    clientId: string
}): Promise<ApiWrapper<ClientVisit[]>> {
    const url = 'GCB2/taskList/client/visitsHistory'
    return apiCall<any>(() => http.get(url, { searchParams: { projectId, clientId } }))
}

/** Лента коммуникаций клиента — рассылки, звонки, комментарии. */
export async function getClientEvents({
    projectId,
    clientId,
}: {
    projectId: string
    clientId: string
}): Promise<ApiWrapper<ClientEvent[]>> {
    const url = 'GCB2/taskList/client/commentHistory'
    return apiCall<any>(() => http.get(url, { searchParams: { projectId, clientId } }))
}

/**
 * Отправить предложение клиенту по каскаду проекта — тот же путь, что у
 * ручной отправки из списка задач. `sent: false` — сообщение не прошло
 * проверку (пустой текст, неверный телефон), причина в `reason`.
 */
export async function sendOffer({
    projectId,
    offer,
}: {
    projectId: string
    offer: {
        clientId: string
        phone: string
        clientName: string | null
        text: string
        /** Канал или каскад из «Канал отправки»; null — канал проекта по умолчанию. */
        sendingSettings: { type: 'channel' | 'cascade'; id: string | number } | null
    }
}): Promise<ApiWrapper<{ sent: boolean; reason: string | null }>> {
    const url = 'GCB2/hotWindows/offer'
    return apiCall<any>(() => http.post(url, { json: { projectId, offer } }))
}
